import * as translationsEn from 'core/assets/locale/locale-en.json';

export const EN = 'en';
export const DEFAULT_LOCALE = EN;
export const LOCALES = [EN];

export const translations: { [key: string]: any} = {
  [EN]: translationsEn,
};
